/**
 * Central state for data collected across the onboarding flow.
 * Flat key-value store; use stateKey like "businessName" with OnboardingTextInput.
 */

import type { BusinessCDDDoc } from '@fragment/billing/platform/entitySchemas';

export type OnboardingState = Omit<
  BusinessCDDDoc,
  | 'workspaceId'
  | 'entity'
  | 'businessEntityId'
  | 'beneficialOwners'
  | 'created'
  | 'instance'
  | 'modified'
>;

type OnboardingFieldValue = OnboardingState[keyof OnboardingState];

export type OnboardingAction =
  | { type: 'SET_FIELD'; stateKey: string; value: OnboardingFieldValue }
  | { type: 'RESET' };

export const onboardingReducer = (
  state: OnboardingState,
  action: OnboardingAction
): OnboardingState => {
  switch (action.type) {
    case 'SET_FIELD':
      return { ...state, [action.stateKey]: action.value };
    case 'RESET':
      return {};
    default:
      return state;
  }
};
